import { render, staticRenderFns } from "./dr-text.vue?vue&type=template&id=5f1277f6&"
import script from "./dr-text.vue?vue&type=script&lang=js&"
export * from "./dr-text.vue?vue&type=script&lang=js&"
import style0 from "./dr-text.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../player/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports